import { Col, Row } from '@/app/components/Flex/Flex'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const ArcanaHead: FunctionalComponent<{
  title: string
  cardHint: string
  description: string
  arcanaId: number
  imageSrc: string
  imageAlt: string
}> = props => {
  return (
    <div class={styles.root}>
      <Row gap={15}>
        <UI.Panel shadow type='user' radius='s'>
          <h1 class={styles.title}>
            <Row gap={5}>
              <Text
                fontSize={20}
                fontWeight={600}
                textAlign='center'
              >
                {props.title}
              </Text>
            </Row>
          </h1>
        </UI.Panel>

        <Col
          grid
          gap={15}
        >
          <UI.Panel class={styles.card}>
            <img
              class={styles.bg}
              src={props.imageSrc}
              alt={props.imageAlt}
            />
          </UI.Panel>

          <UI.Panel class={styles.back}>
            <Row
              gap={10}
              alignItems='center'
              justifyContent='center'
            >
              <div class={styles.id}>
                {props.arcanaId}
              </div>
              <div class={styles.label}>
                Аркан
              </div>
              <div class={styles.hint}>
                {props.cardHint}
              </div>
            </Row>
          </UI.Panel>
        </Col>

        <UI.Panel>
          <Text
            as='p'
            fontSize={16}
          >
            {props.description}
          </Text>
        </UI.Panel>
      </Row>
    </div>
  )
}
